export default __webpack_public_path__ + "static/media/no-transaction.c9e5dde6.png";